import tempMee from '../../../apis/tempMee';

export const REVOKE_SESSION_ENDPOINT = '/auth-service/sessions';

/**
 * Asks auth-service to delete a refresh token: `DELETE /auth-service/sessions`.
 *
 * The route takes the refresh token in the body and needs no `Authorization`.
 * It answers 204 whether or not the token existed, so it is safe to send for a
 * token that may already be gone.
 *
 * @param {string} refreshToken
 * @returns {Promise<void>}
 */
export const revokeSession = async (refreshToken) => {
  await tempMee.delete(REVOKE_SESSION_ENDPOINT, { data: { refreshToken }, skipAuth: true });
};
